/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * トップページに表示する項目と表示順情報
 * @export
 * @interface SiteToppageResponseModel
 */
export interface SiteToppageResponseModel {
    /**
     * 項目名, 値の意味は以下を表します
     * news : 新着情報
     * series : 連載
     * latest_comic : 最新コミックス
     * feature : 特集
     * ranking : ランキング
     * ads : 広告画像
     * reading : 読書中の作品
     * sub_contents : リマコミ＋雑誌一覧
     * today_update_manga : 本日更新のマンガ
     * next_month_releases_comic : 来月の新刊
     * @type {string}
     * @memberof SiteToppageResponseModel
     */
    sectionTitle?: SiteToppageResponseModelSectionTitleEnum;
    /**
     * 並び順 (1が一番上に表示)
     * @type {number}
     * @memberof SiteToppageResponseModel
     */
    displayOrder?: number;
}


/**
 * @export
 */
export const SiteToppageResponseModelSectionTitleEnum = {
    News: 'news',
    Series: 'series',
    LatestComic: 'latest_comic',
    Feature: 'feature',
    Ranking: 'ranking',
    Ads: 'ads',
    Reading: 'reading',
    SubContents: 'sub_contents',
    TodayUpdateManga: 'today_update_manga',
    NextMonthReleasesComic: 'next_month_releases_comic'
} as const;
export type SiteToppageResponseModelSectionTitleEnum = typeof SiteToppageResponseModelSectionTitleEnum[keyof typeof SiteToppageResponseModelSectionTitleEnum];


/**
 * Check if a given object implements the SiteToppageResponseModel interface.
 */
export function instanceOfSiteToppageResponseModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SiteToppageResponseModelFromJSON(json: any): SiteToppageResponseModel {
    return SiteToppageResponseModelFromJSONTyped(json, false);
}

export function SiteToppageResponseModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteToppageResponseModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sectionTitle': !exists(json, 'section_title') ? undefined : json['section_title'],
        'displayOrder': !exists(json, 'display_order') ? undefined : json['display_order'],
    };
}

export function SiteToppageResponseModelToJSON(value?: SiteToppageResponseModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'section_title': value.sectionTitle,
        'display_order': value.displayOrder,
    };
}

